/**
 * Education Reward Detail Route
 */

import React from 'react';
import EducationRewardDetail from './EducationRewardDetail';
import getItemById from '../../../../../data/fetch/getItemById';

async function action({ fetch, store }, routeParams) {
  const module = 'content';
  const fields =
    '_id n desc dc dm tags gallery { media { _id }} ecommerce { price { amount currency }} data { distributor locationName province city dateTime inventoryLimit redemptionLimit subCategory }';
  const graphQLTypes = ['EducationReward'];
  const { siteId } = routeParams;
  const json = await getItemById(
    fetch,
    siteId,
    module,
    fields,
    routeParams.id,
    graphQLTypes,
  );

  if (json == null) {
    return null;
  }

  const state = store.getState();
  const userData = (state.session || {}).USER_DATA;
  const modules = ((userData || {}).group || {}).modules || [];
  const isSalon = !!(userData || {}).salon;
  let sidebarKey = 'loyalty';
  if (modules.includes('loyalty') && isSalon) {
    sidebarKey = 'clubskpLoggedInSalon';
  } else if (modules.includes('loyalty') && userData) {
    sidebarKey = 'clubskpLoggedIn';
  }

  return {
    chunks: ['loyalty'],
    title: json.n,
    component: (
      <EducationRewardDetail
        item={json}
        siteId={siteId}
        sidebarKey={sidebarKey}
        paths={[
          {
            url: `/${siteId}/education-rewards`,
            title: 'Education Rewards',
          },
          { url: '', title: json.n },
        ]}
      />
    ),
    trackingData: {
      tags: (json || {}).tags,
      category: ((json || {}).data || {}).subCategory,
      n: (json || {}).n,
      _id: (json || {})._id,
    },
    routeParams,
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/routes/client/site/education-rewards/detail/index.js